(ns common.schema.entities.counterparty-diligence.templates.questions.common
  (:require
   [common.util :as cu]
   [clojure.string :as string]
   [common.schema.entities.counterparty-diligence.templates.validation :as validation]))

(def signatories
  {:field          :signatories
   :data-type      :data.type/vector
   :item-data-type :data.type/map
   :item-template  {:template/schema
                    {:full-name
                     {:label {:en "Full name"}
                      :data-type :data.type/text-simple}

                     :email
                     {:label {:en "Email"}
                      :data-type :data.type/text-simple}}}
   :editor-type     :editor.type/signatory-list
   :visibility-fn   (fn [{:keys [e-signature-required?]}]
                      e-signature-required?)
   :validation-fn
   (fn [{:keys [data e-signature-required? draft?]}]
     (let [required? (and (not draft?)
                          e-signature-required?)
           signatories (get data :signatories [])]

       (cond
         (or (not (vector? signatories))
             (not (every? map? signatories)))
         {:general :validation.error/invalid-data-type}

         (and required?
              (empty? signatories))
         {:general :validation.error/at-least-one-signatory-required}

         required?
         (let [item-errors
               (->> signatories
                    (mapv (fn [{:keys [full-name email]}]
                            (let [full-name (-> full-name
                                                (or "")
                                                string/trim)
                                  email (-> email
                                            (or "")
                                            string/trim)

                                  field-errors
                                  (->> {:full-name (when (cu/blank-value? full-name)
                                                     :validation.error/field-required)
                                        :email (when (cu/blank-value? email)
                                                 :validation.error/field-required)}
                                       (remove (fn [[_field error]]
                                                 (nil? error)))
                                       (into {}))]
                              (when (seq field-errors)
                                {:fields field-errors})))))

               item-errors? (->> item-errors
                                 (remove nil?)
                                 seq)]
           (when item-errors?
             {:items item-errors})))))})

(def role-in-transaction
  {:field :role-in-transaction
   :data-type :data.type/keyword
   :linked-fields [:role-in-transaction-other]
   :label     {:en "Role in the transaction"}
   :options   [{:value :seller
                :label "Seller"}
               {:value :purchaser
                :label "Purchaser"}
               {:value :target
                :label "Target"}
               {:value :other
                :label "Other"}]})

(def role-in-transaction-other
  {:field :role-in-transaction-other
   :data-type :data.type/text-simple
   :label {:en "Specify the role in the transaction"}
   :visibility-fn (fn [{:keys [data]}]
                    (-> data
                        :role-in-transaction
                        (= :other)))
   :validation-fn (fn [{:keys [value data draft?]}]
                    (let [other-role? (-> data
                                          :role-in-transaction
                                          (= :other))
                          mandatoriness (if (or draft?
                                                (not other-role?))
                                          :mandatory/optional
                                          :mandatory/always)]
                      (validation/validate-text-field
                       {:field-config {:mandatoriness mandatoriness}}
                       value)))})
